import { configureStore } from '@reduxjs/toolkit'
import cafmReducer from '../CAFM/features/cafm/cafmSlice'
import EditFieldMappingReducer from '../CAFM/features/cafm/FieldMappingEditSlice'
import MasterDataReducer from '../CAFM/features/cafm/MasterDataSlice'
import deciderFieldsReducer from '../CAFM/features/cafm/deciderFieldsSlice'
import updateFieldMappingReducer from '../CAFM/features/cafm/EditFieldMappinPayloadSlice'
import operationDetailsReducer from '../CAFM/features/cafm/operationDetailsSlice'
import secretValueReducer from '../CAFM/features/cafm/secretValueSlice'
import customLogsReducer from '../Dashboard/CAFMDashboard/slices/logs'
import kensDetailsSlice from '../Dashboard/ControlTools/Slices/KenDetails'
import createReportSlice from '../Dashboard/ControlTools/Slices/CreateReport'

// Create the store
const store = configureStore({
  reducer: {
    cafm: cafmReducer,
    EditFieldMapping: EditFieldMappingReducer,
    MasterData: MasterDataReducer,
    deciderFields: deciderFieldsReducer,
    updateFieldMapping: updateFieldMappingReducer,
    OpeationDetails: operationDetailsReducer,
    SecretValue: secretValueReducer,
    customLogs: customLogsReducer,
    kensDetails: kensDetailsSlice,
    createReport: createReportSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

// Export the store
export default store

// Define RootState type
export type RootState = ReturnType<typeof store.getState>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch
